<div class="auth-settings-root">
  <form [formGroup]="form">
    <div class="mb-3">
      <input type="checkbox" (change)="checkChanged()" [formControl]="gwEnabled" />
      <span class="uv-checkbox-label auth-settings-heading-1">Enable Google Workspace Users and Groups</span>
    </div>
    <div class="mb-3 auth-settings-row-1">
      <span class="auth-settings-heading-2">Basic Settings</span>
    </div>
    <div class="mb-3 auth-settings-row-2">
      <span class="auth-settings-label">Domain Names (e.g., acme.com)</span>
    </div>
    <div class="mb-3 auth-settings-row-2">
      <textarea class="form-control auth-settings-domains" [formControl]="gwDomainNames"></textarea>
    </div>
    @if (gwDomainNames.hasError('gwDomainNamesRequired')) {
      <div class="mb-3 auth-settings-row-2">
        <div class="auth-settings-domains-error alert alert-danger">
          This field is required.
        </div>
      </div>
    }
    <div class="mb-3 auth-settings-row-2">
      <span class="auth-settings-label">Query Page Size:</span>
      <input type="number" pInputText min="1" max="200" class="auth-settings-page-size" [formControl]="gwQueryPageSize" />
    </div>
    @if (gwQueryPageSize.hasError('minValue') || gwQueryPageSize.hasError('maxValue')) {
      <div class="mb-3 auth-settings-row-2">
        <div class="auth-settings-page-size-error alert alert-danger">
          This field is required and must be in the range 1 - 200.
        </div>
      </div>
    }
    <div class="mb-3 auth-settings-row-1">
      <span class="auth-settings-heading-2">Update Settings</span>
    </div>
    <div class="mb-3 auth-settings-row-2">
      <input type="checkbox" [formControl]="gwAutoSyncDirectoryDataEnabled" (change)="checkChanged()" />
      <span class="uv-checkbox-label">Automatically refresh cached Google Workspace data every</span>
      <input class="form-control auto-sync-input" type="number" min="0" max="30" [formControl]="gwAutoSyncDirectoryDataDays" />
      <span class="auto-sync-text">days</span>
      <input class="form-control auto-sync-input" type="number" min="0" max="23" [formControl]="gwAutoSyncDirectoryDataHours" />
      <span class="auto-sync-text">hours</span>
      <input class="form-control auto-sync-input" type="number" min="0" max="59" [formControl]="gwAutoSyncDirectoryDataMinutes" />
      <span class="auto-sync-text">minutes</span>
      <span style="padding-left: 5px;">&nbsp;</span>
      <info width="500px">Auto update will use the Google Workspace admin credentials last used to save Google Workspace settings.</info>
    </div>
    @if (gwAutoSyncDirectoryDataDays.hasError('required') || gwAutoSyncDirectoryDataDays.hasError('min') || gwAutoSyncDirectoryDataDays.hasError('max')) {
      <div
        class="mb-3 auth-settings-row-2">
        <div class="col-lg-3 alert alert-danger">
          Days value must be in the range 0 - 30
        </div>
      </div>
    }
    @if (gwAutoSyncDirectoryDataHours.hasError('required') || gwAutoSyncDirectoryDataHours.hasError('min') || gwAutoSyncDirectoryDataHours.hasError('max')) {
      <div
        class="mb-3 auth-settings-row-2">
        <div class="col-lg-3 alert alert-danger">
          Hours value must be in the range 0 - 23
        </div>
      </div>
    }
    @if (gwAutoSyncDirectoryDataMinutes.hasError('required') || gwAutoSyncDirectoryDataMinutes.hasError('min') || gwAutoSyncDirectoryDataMinutes.hasError('max')) {
      <div
        class="mb-3 auth-settings-row-2">
        <div class="col-lg-3 alert alert-danger">
          Minutes value must be in the range 0 - 59
        </div>
      </div>
    }
    @if (form.hasError('nonEmptyAutoSyncSettings')) {
      <div
        class="mb-3 auth-settings-row-2">
        <div class="col-lg-3 alert alert-danger">
          A time frame of 15 minutes or more must be specified
        </div>
      </div>
      }		<div class="auth-settings-divider">
    </div>
    <div>
      <div style="display: inline-block; width: 50px;">&nbsp;</div>
      <button pButton (click)="onSave()" [disabled]="!enableSave()" label="Save Google Workspace Settings"></button>
    </div>
  </form>

  <google-admin-dialog [(display)]="gwAdminDialogVisible" messageType="group"
    (onOk)="onGwAdminDialogOkClicked()" (onCancel)="onGwAdminDialogCancelClicked()">
  </google-admin-dialog>

</div>